export enum SurveyEditorTab {
  Questions = 'Questions',
}
